import {computed} from "vue";
import {helpers, requiredIf} from "@vuelidate/validators";
import { numeric } from "@vuelidate/validators";
import {useOrderDataStore} from "@/stores/orderDataStore";
import {UseMoneyStore} from "@/stores/moneyStore";
import {useI18n} from "vue-i18n";


export const useProductsValidation = (
    products, productStore, atLeastOneChecked, ibanLength, isValidIban) => {
    const orderDataStore = useOrderDataStore();
    const {t} = useI18n()

    // Validation rules
    const rules = {
        products: computed(() => {
            return products.value.map((product) => ({
                returnReasons: {
                    required: helpers.withMessage(
                        t('products.selectReturnReason'),
                        () => productStore.isChecked[product.id] ? !!productStore.returnReasons[product.id] : true
                    ),
                },
                productDesc: {
                    required: helpers.withMessage(
                        t('products.enterProductDescription'),
                        requiredIf(() =>
                            productStore.isChecked[product.id] &&
                            ['wrongProduct', 'defective'].includes(productStore.returnReasons[product.id]) &&
                            !productStore.productDesc[product.id]
                        )
                    ),
                },

            }));
        }),

        selectedProducts: {
            required: helpers.withMessage(t('products.selectAtLeastOne'), requiredIf(() => !atLeastOneChecked.value)),
        },
        selectedHowReturnMoney: {
            required: helpers.withMessage(t('products.selectReturnMethod'), requiredIf(() => atLeastOneChecked.value)),
        },
        ibanDigits: {
            required: helpers.withMessage(t('products.enterIban'), requiredIf(() => UseMoneyStore().selectedHowReturnMoney === 'iban' )),
            numeric: helpers.withMessage(t('products.invalidIban'),
                (value) => {
                    return (UseMoneyStore().selectedHowReturnMoney === 'iban')
                        ? numeric.$validator(value)
                        : true;
                }
            ),
            // minLength: helpers.withMessage('Το IBAN είναι πολύ μικρό', minLength(ibanLength)),
            minLength: helpers.withMessage(t('products.ibanTooShort'),
                (value) => {
                    if(UseMoneyStore().selectedHowReturnMoney === 'iban'){
                        return value.length >= ibanLength.value;
                    }
                    return true;
                }
            ),
            maxLength: helpers.withMessage(t('products.ibanTooLong'),
                (value) => {
                    if(UseMoneyStore().selectedHowReturnMoney === 'iban'){
                        return value.length <= ibanLength.value;
                    }
                    return true;
                }
            ),
            validFormat: helpers.withMessage(t('products.invalidIban'),
                (value) => {
                    if(UseMoneyStore().selectedHowReturnMoney === 'iban') {
                        const countryCode = orderDataStore.shippingCountry === 'GR' ? 'GR' : 'CY';
                        return isValidIban(countryCode + value);
                    }
                    return true;
                }
            )
        },
        beneficiaryName: {
            required: helpers.withMessage(t('products.enterBeneficiaryName'), requiredIf(() => UseMoneyStore().selectedHowReturnMoney === 'iban')),
            alpha: helpers.withMessage(t('products.invalidBeneficiaryName'),
                (value) => {
                   if(UseMoneyStore().selectedHowReturnMoney === 'iban') {
                       return /^[\p{L} ]+$/u.test(value);
                   }
                   return true;
                }
            )
        },
        ibanBank: {
            required: helpers.withMessage(t('products.enterBankName'), requiredIf(() => UseMoneyStore().selectedHowReturnMoney === 'iban')),
            alpha: helpers.withMessage(t('products.invalidBankName'),
                (value) => {
                    if(UseMoneyStore().selectedHowReturnMoney === 'iban') {
                        return /^[\p{L} ]+$/u.test(value);
                    }
                    return true;
                }
            )
        },

    };
    return { rules };
};
